<template>
	<div class="doclib-footer-dialog" @click="closeFooterDialog">
    <div class="content-dialog" @click="clickContentDialog">
      <slot></slot>
    </div>
	</div>
</template>
<script>

export default {
  name: 'CommonFooterDialog',
  props: {

  },
  data () {
    return {

    }
  },
  created () {

  },
  computed: {

  },
  watch: {
  },
  mounted () {

  },
  methods: {
    closeFooterDialog () {
      this.$emit('close-dialog')
    },
    clickContentDialog (e) {
      e.stopPropagation()
    }
  }
}
</script>
<style lang="postcss" scoped>
	@import 'variables';
  .doclib-footer-dialog {
		position: fixed;
		width: 100%;
		height: 100%;
		z-index: 10000;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, 0.50);
		display: flex;
		flex-direction: column;
		justify-content: flex-end;

    & .content-dialog {
      border-radius: 16px 16px 0px 0px;
      background: #FFF;
			padding: 20px 24px 34px;
    }
  }
</style>
